<ng-container *transloco="let t; read: 'conversation-info-dialog'">
  <p-toast position="bottom-center"></p-toast>

  <legend>
    {{ t('dialogHeader') }}
  </legend>

  <app-progress-spinner *ngIf="loading"></app-progress-spinner>

  <div *ngIf="!loading && communicationsResponseGetConversationLogPII?.getError() !== undefined">
    {{ t('nothingToShow') }}
  </div>

  <div *ngIf="!loading && communicationsResponseGetConversationLogPII?.getError() === undefined">
    <!-- Phone Number -->
    <div class="field grid">
      <label for="e164Phone" style="width: 200px">{{ t('e164PhoneLabel') }}</label>
      <div class="col">
        <input
          class="full-width"
          id="e164Phone"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetConversationLogPII?.getIdentity()?.getE164Phone() }}"
        />
      </div>
    </div>

    <!-- IP Address -->
    <div class="field grid">
      <label for="ipAddress" style="width: 200px">{{ t('ipAddressLabel') }}</label>
      <div class="col">
        <input
          class="full-width"
          id="ipAddress"
          pInputText
          type="text"
          [disabled]="true"
          value="{{ communicationsResponseGetConversationLogPII?.getIdentity()?.getIpAddress() }}"
        />
      </div>
    </div>
  </div>

  <div>
    <div class="row">
      <div *ngIf="!loading" class="col flex justify-content-start align-items-end flex-wrap">
        {{ t('dialogFooter', { dataRetentionDurationFormatted, dataRetentionEnd: dataRetentionEndFormatted }) }}
      </div>
      <div class="col flex justify-content-end flex-wrap">
        <p-button
          icon="pi pi-check"
          styleClass="p-button-text"
          label="{{ t('closeButtonLabel') }}"
          (click)="closeDialog()"
        ></p-button>
      </div>
    </div>
  </div>
</ng-container>
